<template>
  <div class="changePharmacy">
    <Loading v-if="loading" />
    <div class="changePharmacy__image">
      <div class="container">
        <img
          class="image"
          src="@/assets/icons/login-img.jpg"
          alt="Noutoapteekk"
        />
      </div>
    </div>
    <div class="changePharmacy__content">
      <div class="container">
        <div class="changePharmacy__content-head">
          <div class="changePharmacy__content-head-backTo" @click="backTo">
            <Link :title="$t('backToLogIn')" />
          </div>
        </div>
        <div class="changePharmacy__content-form">
          <div class="form">
            <div class="form-title">
              <p>{{ $t('choosePharmacy') }}</p>
            </div>
            <FormKit id="lang-form" type="form" :actions="false">
              <Dropdown
                class="changePharmacy-dropdown"
                :selected-option="selectedPharmacy"
                :options="pharmacyOptions"
                :placeholder-text="$t('placeholderText')"
                @select-option="selectPharmacy"
              />
            </FormKit>
            <Button
              id="login"
              variant="logIn"
              type="button"
              :title="$t('changePharmacy')"
              @click="goToLockers"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';

import router from '@/router';

import { Option } from '@/types';
import { PharmacyOption } from '@/store/modules/users/types';

import { goToPickupBox } from '@/utils/goToPickupBox';
import { goToEditPharmacy } from '@/utils/goToEditPharmacy';

@Options({
  name: 'ChangePharmacy',
  components: {
    Loading
  },
  data() {
    return {
      loading: false,
      selectedPharmacy: {
        value: '',
        label: ''
      },
      pharmacyOptions: [],
      pharmacyLoading: true,
      allPharmacies: [],
      activePharmacy: null,
      pharmacies: {}
    };
  },
  created() {
    this.show();
  },
  computed: {
    ...mapState('account', ['user']),
    ...mapState('pharmacy', ['pharmacy']),
    ...mapState('users', ['users', 'pharmacyAccesses']),
    ...mapState('entityNames', ['entityNames'])
  },
  methods: {
    ...mapActions('users', ['getPharmacyAccesses', 'updatePharmacyAccess']),
    ...mapActions('entityNames', ['getEntityNames']),
    ...mapActions('account', ['loginToPharmacy', 'logoutToken']),
    ...mapActions('pharmacy', ['getPharmacy']),
    async show() {
      this.loading = true;

      await this.getEntityNames();
      this.pharmacies = this.entityNames.pharmacies;

      this.initPharmacyOptions();
      this.loading = false;
    },
    getEntityName(name: string, entities: Record<string, unknown>) {
      const entity = Object.entries(entities).find((item) =>
        item[0].includes(name)
      );

      return entity ? entity[1] : null;
    },
    initPharmacyOptions() {
      const pharmaciesData = this.$route.query.data;

      this.pharmacyOptions = pharmaciesData.map((pharmacy: PharmacyOption) => ({
        value: pharmacy,
        label: this.getEntityName(pharmacy, this.pharmacies),
        img: require('@/assets/icons/Apoteket.svg')
      }));
    },
    selectPharmacy(option: Option) {
      this.selectedPharmacy = option;

      this.activePharmacy = this.allPharmacies.find(
        (pharmacy: PharmacyOption) => pharmacy.id === option.value
      );
    },
    async goToLockers() {
      const data = {
        pharmacyId: this.selectedPharmacy.value
      };

      this.loading = true;

      try {
        await this.updatePharmacyAccess(data);
        await this.loginToPharmacy();
        this.getTabs();

        localStorage.setItem('id', this.selectedPharmacy.value);
        const savedLocale = localStorage.getItem('locale');

        if (savedLocale) {
          this.$i18n.locale = savedLocale;
        }
      } catch (e) {
        console.log(e);
      }

      this.loading = false;
    },
    async getTabs() {
      this.loading = true;
      this.pharmacyLoading = true;

      await this.getPharmacy(this.user?.pharmacyId);

      this.boxId = this.pharmacy?.pickupBoxes[0];
      this.pharmacyLoading = false;

      if (!this.pharmacyLoading && this.user) {
        if (this.pharmacy?.remomediServices.pickupbox && this.boxId) {
          return goToPickupBox(
            this.user?.pharmacyId,
            this.pharmacy?.pickupBoxes[0]
          );
        } else {
          return this.pharmacy?.remomediServices.mobileApp
            ? router.push({ name: 'CallerAuthentication' })
            : goToEditPharmacy(this.user.pharmacyId);
        }
      }

      this.loading = false;
    },
    async backTo() {
      await this.logoutToken();
    }
  }
})
export default class ChangePharmacy extends Vue {}
</script>

<style lang="scss" scoped>
.changePharmacy {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100vw;
  height: 100vh;
  .changePharmacy__image {
    width: 50%;
    height: 100vh;
    .container {
      width: 100%;
      height: 100%;
      background-color: $light-grey;
      .image {
        max-width: 100vh;
        height: 100vh;
      }
    }
  }
  .changePharmacy-dropdown {
    height: 48px;
    width: 352px;
  }
  .changePharmacy__content {
    width: 50%;
    height: 100vh;
    .container {
      width: 100%;
      height: 100%;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: $light-grey;
      .changePharmacy__content-head {
        .changePharmacy__content-head-backTo {
          position: absolute;
          display: flex;
          align-items: center;
          width: max-content;
          height: 50px;
          left: 32px;
          top: 32px;
          padding: 0 16px;
          border-radius: 8px;
          background-color: $white;
          cursor: pointer;
        }
      }
      .changePharmacy__content-form {
        max-width: 416px;
        border-radius: 8px;
        .form {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          row-gap: 25px;
          padding: 32px;
          border-radius: 8px;
          background: $white;
          .form-title {
            width: 352px;
            margin-bottom: 16px;
            p {
              font-size: $twentyFourSize;
              line-height: $twentyEightSize;
              font-family: 'Ubuntu-Medium';
            }
          }
          .form-text {
            width: 352px;
            margin-bottom: 30px;
            p {
              font-size: $fourteenSize;
              line-height: $twentyOneSize;
              font-weight: 400;
              color: $label;
            }
          }
          .form-input {
            width: 352px;
            margin-bottom: 32px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.form-inputs {
  .formkit-outer {
    .formkit-wrapper {
      .formkit-inner {
        .formkit-input {
          &:hover {
            border: 1px solid $main-green;
          }
        }
      }
    }
  }
}
</style>

function commit(arg0: string) { throw new Error("Function not implemented."); }
